import { render, staticRenderFns } from "./baseData.vue?vue&type=template&id=7f957f1f&scoped=true&"
import script from "./baseData.vue?vue&type=script&lang=js&"
export * from "./baseData.vue?vue&type=script&lang=js&"
import style0 from "./baseData.vue?vue&type=style&index=0&id=7f957f1f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f957f1f",
  null
  
)

export default component.exports